<template>
  <div class="provider">
    <SidebarLayout2
      :breadcrumb="breadcrumb"
      :rootPath="rootPath"
      :pageTitle="pageTitle"
    >
      <!-- BARRA LATERAL -->
      <template #sidebar class="sidebar">
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>Ações da página</Heading>
          <!-- CADASTRAR -->
          <Button
            :hasIcon="true"
            :link="'/fornecedores/criar'"
            element="router-link"
            class="page-actions--button"
            data-cy="create-provider"
          >
            Cadastrar fornecedor
          </Button>

          <!-- EDITAR GRUPO DE USUÁRIOS -->
          <Button
            :disabled="selectedProviders.length !== 1"
            :link="
              `/fornecedores/editar/${
                selectedProviders[0] ? selectedProviders[0].codigo : null
              }`
            "
            element="router-link"
            class="page-actions--button"
          >
            Editar
          </Button>
          <!-- DESATIVAR -->
          <Button
            :disabled="selectedProviders.length === 0"
            variation="error"
            class="page-actions--button"
            data-cy="delete-provider"
            @click="showConfirmationInactiveModal = true"
          >
            Desativar
          </Button>
        </SidebarBlock>
      </template>
      <template #content class="content">
        <div class="filters">
          <SearchInput
            v-model="search"
            class="filters--search"
            data-cy="search-provider"
          />
          <FilterDropdown
            v-model="status"
            :options="statusFilterOptions"
            class="filters--status"
          ></FilterDropdown>
        </div>
        <DataTable
          :cols="datatable.gridColumns"
          :rows="searchProviders"
          :isLoading="false"
          :selectableRow="true"
          :sortable="true"
          :colsMinWidths="datatable.colsMinWidths"
          class="datatable"
          ref="datatable"
          data-cy="datatable"
          notFoundMessage="Não há fornecedores para apresentar."
          @getSelectedRows="manageSelectedProviders"
        >
          <!-- Status -->
          <template v-slot:status="{ col }">
            <span v-if="col">Ativo</span>
            <span v-else>Inativo</span>
          </template>
          <!-- Ações -->
          <template v-slot:action="slotProps">
            <router-link
              :to="`/fornecedores/editar/${slotProps.rowDataObj.codigo}`"
              class="links links--edit"
              data-cy="edit-provider"
            >
              Editar
            </router-link>
          </template>
        </DataTable>
      </template>
    </SidebarLayout2>
    <!-- MODAL - EXCLUIR FORNECEDOR -->
    <AlertModal
      v-model="showConfirmationInactiveModal"
      title="Desativar fornecedor(es)"
      @alert-modal-confirm="inativeProviders"
      @alert-modal-cancel="resetProviders"
    >
      <template #text>
        Ao desativar, esse fornecedor não estará mais <br />
        disponível para vínculo com novos produtos. <br />
        Tem certeza que quer fazer isso?
      </template>
    </AlertModal>
    <!-- MODAL - ATENÇÃO -->
    <AlertModal
      v-model="showAlertModal"
      icon="alert"
      sizeIcon="large"
      confirmButtonText="Ok, entendi"
      cancelButtonText="Cancelar"
      title="Atenção"
      @alert-modal-confirm="showAlertModal = false"
      @alert-modal-cancel="showAlertModal = false"
    >
      <template #text>
        Não é possível desativar, pois esse fornecedor <br />
        está vinculado a um produto ativo. Para <br />
        desativar, é necessário desvincula-lo do produto.
      </template>
    </AlertModal>
  </div>
</template>

<script>
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'

export default {
  name: 'Provider',
  components: {
    SidebarLayout2,
    SidebarBlock,
    Heading,
    Button,
    SearchInput,
    FilterDropdown,
    DataTable,
    AlertModal
  },
  data() {
    return {
      pageTitle: 'Fornecedores',
      rootPath: {
        /** ponto de partida do breadcrumb  */
        label: 'Home',
        url: 'relatorio-conversao',
        isSpa: false /** se deve ser um link para o site novo ou antigo */
      },
      breadcrumb: [
        {
          label: 'Configurações',
          url: '',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Fornecedores',
          url: '/fornecedores',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],
      search: null,
      status: null,
      statusFilterOptions: [
        {
          label: 'Todos',
          value: null,
          checked: false
        },
        {
          label: 'Ativos',
          value: true,
          checked: true
        },
        {
          label: 'Inativos',
          value: false,
          checked: false
        }
      ],
      datatable: {
        /** colunas da tabela */
        gridColumns: [
          { name: 'name', alias: 'Nome' },
          { name: 'status', alias: 'Status' },
          { name: 'action', alias: 'Ações' }
        ],
        /** Largura das colunas */
        colsMinWidths: {
          name: '0px',
          status: '132px',
          action: '71px'
        }
      },
      /** Dados dos fornecedores */
      providers: [],
      /** Fornecedores selecionados */
      selectedProviders: [],
      /** Fornecedores selecionado */
      selectedProvider: [],
      /** Mostrar modal de confirmação de remoção */
      showConfirmationInactiveModal: false,
      /** Mostrar modal de alerta */
      showAlertModal: false
    }
  },
  computed: {
    searchProviders() {
      let data = this.providers
      /** Filter by search*/
      if (this.search !== null && this.search !== '')
        data = data.filter((item) =>
          item.nome.toLowerCase().includes(this.search.toLowerCase())
        )
      /** Filter by status */
      if (this.status !== null && this.status.value !== null) {
        data = data.filter((item) => item.ativo === this.status.value)
      }
      return data
    }
  },
  created() {
    this.getProviders()
  },
  methods: {
    /** Pegar fornecedores */
    getProviders() {
      this.$provider
        .get()
        .then((response) => {
          /** Ordenar dados */
          const results = response.data.sort((a, b) =>
            a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
          )
          /** Formatação dos dados */
          results.map(function(key, index) {
            results[index]['data'] = {
              codigo: key.codigo,
              name: key.nome,
              status: key.ativo,
              action: key.codigo
            }
          })
          this.providers = results
        })
        .catch(function() {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao apresentar a listagem de fornecedores.'
          })
        })
    },
    /** Inativar fornecedores */
    inativeProviders() {
      const fornecedores = this.selectedProviders.map((a) => a.codigo)
      this.$provider
        .delete(fornecedores)
        .then(() => {
          /** Feedback */
          this.$bus.$emit('show-alert-chip', {
            message: 'Fornecedor(es) desativado(s) com sucesso.'
          })
          /** Resetar tabela */
          this.resetProviders()
        })
        .catch(() => {
          /** Mostrar modal de alerta */
          this.showAlertModal = true
        })
    },
    /** Selecionar os fornecedores da tabela */
    manageSelectedProviders(values) {
      this.selectedProviders = values
    },
    /** Resetar dados */
    resetProviders() {
      this.showConfirmationInactiveModal = false
      this.selectedProviders = []
      this.selectedProvider = null
      this.getProviders()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.sidebar {
  .page-actions {
    .heading {
      margin-bottom: 15px;
    }
    &--button {
      margin-bottom: 10px;
    }
  }
}
.filters {
  margin-bottom: 30px;
  &--search {
    width: 100%;
    max-width: 215px;
    margin-bottom: 15px;
  }
  &--status {
    width: 100%;
    max-width: 175px;
  }
}
.datatable {
  max-height: initial;
  ::v-deep {
    max-height: initial;
    @include scrollbars(4px, #e8e8e8, #fff);

    .pmw-td span {
      font-size: font-size('size-small');
    }

    .pmw-col.pmw-th,
    .pmw-col.pmw-td {
      min-width: initial;
    }

    /** Largura - Status */
    .pmw-col.pmw-th:nth-child(3),
    .pmw-col.pmw-td:nth-child(3) {
      max-width: 132px;
    }

    /** Largura - Ações */
    .pmw-col.pmw-th:nth-child(4),
    .pmw-col.pmw-td:nth-child(4) {
      max-width: 71px;
    }

    .pmw-col.pmw-th:nth-child(4) {
      pointer-events: none;
      .pmw-icon {
        display: none;
      }
    }

    .links {
      font-size: font-size('size-small');
      font-weight: 500;
      cursor: pointer;
      &--edit {
        color: #466af0;
      }
      &--delete {
        color: #e0414b;
      }
    }
  }
}
</style>
